import { NgModule } from "@angular/core";
import { RouterModule } from  '@angular/router';
import { ItemsContianerComponent } from "./components/items-container-component/items-container.component";
import { CashierIndexComponent } from "./cashier/cashier-index-component/cashier-index.component";
import { QRmenaCashierHomeComponent } from "./cashier/cashier-home-component/cashier-home.component";

@NgModule({
    imports:[RouterModule.forChild([

       {
                    path: "QRMENA",
                    component:CashierIndexComponent,
                        children: [
                            {
                                path: "ITEMS-PAGE",
                                component: ItemsContianerComponent,
                                data: {
                                    
                                },
                            },
                             {
                                path: "home",
                                component: QRmenaCashierHomeComponent,
                                data: {
                                    
                                },
                            },
                        ]
       }
    ])]
})
export class QrMenaRoutingModule{}


// WEBPACK FOOTER //
// ./src/QrMena/qrmena-routing.module.ts